import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setRevenueCenter } from '@sonifi/wb-in-room-dining/store/settings/irdSettingsSlice';

const RevenueCenterSelector = ({ onChange }) => {
  const revenueCenters = useSelector(
    (state) => state.irdSettings.revenueCenters,
  );
  const revenueCenterSelected = useSelector(
    (state) => state.irdSettings.revenueCenterSelected,
  );
  const dispatch = useDispatch();

  const onSelectRevenueCenter = (id) => {
    const revenueCenter = revenueCenters.find((rc) => rc.id === id);
    dispatch(setRevenueCenter({ revenueCenter }));
    onChange(revenueCenter);
  };

  if (!revenueCenters.length || revenueCenters.length === 1) {
    return null;
  }

  return (
    <li className="ddPosition">
      <select
        className="ddValueView"
        value={revenueCenterSelected?.id}
        onChange={(e) => onSelectRevenueCenter(parseInt(e.target.value))}
      >
        {revenueCenters.map((rc) => (
          <option key={rc.id} value={rc.id}>
            {rc.title}
          </option>
        ))}
      </select>
    </li>
  );
};

export default RevenueCenterSelector;
